<template>
    <div class="px-3">
        <div v-for="group in workflowOperators" class="mt-2">
            <h6>{{ group.label }}</h6>
            <span v-for="(operator, idx) in group.list">
                <span @click="onOperatorClick(operator)" class="operator-tag">
                    {{ operator }}
                </span><template v-if="idx + 1 < group.list.length">, </template>
            </span>
        </div>
    </div>
</template>

<script>
import {workflowOperators} from '../../../../models/workflow/api/operators'

export default {
    name: 'TabOperators',
    props: {},
    data() {
        return {
            workflowOperators
        }
    },
    methods: {
        onOperatorClick(operator) {
            this.$emit('select', operator)
        }
    }
}
</script>

<style lang="scss" scoped>
    .operator-tag {
        display: inline-block;
        border-radius: 4px;
        background: $color-grey-light;
        margin-right: 2px;
        margin-bottom: 2px;
        padding: 2px 4px;

        &:hover {
            cursor: pointer;
        }
    }
</style>
